"use client";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";

interface DocumentBreadcrumbsProps {
	isRootLibrary: boolean;
	onRootClick: () => void;
	selectedLibraryName: string;
}

const DocumentBreadcrumbs = ({
	isRootLibrary,
	onRootClick,
	selectedLibraryName,
}: DocumentBreadcrumbsProps) => {
	const items = [
		<Typography
			key="1"
			variant="subtitle1"
			className="font-semibold"
			color="text.primary"
			onClick={onRootClick}
			sx={{ cursor: "pointer" }}
		>
			Thư viện của bạn
		</Typography>,
	];

	if (!isRootLibrary) {
		items.push(
			<Typography
				key="2"
				sx={{ color: "text.primary" }}
				variant="subtitle1"
				className="font-semibold"
			>
				{selectedLibraryName}
			</Typography>,
		);
	}

	return (
		<Breadcrumbs
			separator={<NavigateNextIcon fontSize="small" />}
			aria-label="breadcrumb"
			className="w-full"
			sx={{
				"& ol": {
					columnGap: "4px",
					flexWrap: "nowrap",
				},
				"& ol li:last-child": {
					flex: 1,
					wordBreak: "break-word",
					overflow: "hidden",
					textOverflow: "ellipsis",
					display: "-webkit-box",
					WebkitLineClamp: "1",
					WebkitBoxOrient: "vertical",
				},
			}}
		>
			{items}
		</Breadcrumbs>
	);
};

export default DocumentBreadcrumbs;
